import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { shallowRef, watch } from 'vue';
import { useLayoutStore } from '@/store/layout';
import { storeToRefs } from 'pinia';
import InternalModules from '@/models/InternalModules';
import getEmbeddedInModule from '@/helpers/getEmbeddedInModule';

const defaultLayout = 'AppLayoutOpenInFSC';

export default /*@__PURE__*/_defineComponent({
  __name: 'AppLayout',
  async setup(__props) {

let __temp: any, __restore: any

const getLayoutComponent = async function (name: string | null) {
  const resolvedLayout = name ?? defaultLayout;
  return (
    await import(
      /* webpackChunkName: "app-layout-[request]" */
      `@/layouts/${resolvedLayout}.vue`
    )
  ).default;
};

const layoutStore = useLayoutStore();
const { layout } = storeToRefs(layoutStore);
const layoutComponent = shallowRef((
  ([__temp,__restore] = _withAsyncContext(() => getLayoutComponent(layout.value))),
  __temp = await __temp,
  __restore(),
  __temp
));
const embeddedIn = getEmbeddedInModule();

const hideHeader = embeddedIn === InternalModules.ScreeningCenter;

watch(layout, async () => {
  layoutComponent.value = await getLayoutComponent(layout.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(hideHeader ? 'fragment' : layoutComponent.value), null, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})